/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'page': {
    width: 17,
    height: 18,
    viewBox: '0 0 17 18',
    data: '<path pid="0" d="M11.446 0a2.669 2.669 0 012.666 2.666v1.105h.15a2.52 2.52 0 012.517 2.517v9.046A2.67 2.67 0 0114.112 18H2.666A2.669 2.669 0 010 15.334V2.666A2.669 2.669 0 012.666 0h8.78zm0 1.23h-8.78c-.791 0-1.435.645-1.435 1.436v12.668c0 .791.644 1.435 1.435 1.435h11.446c.792 0 1.436-.644 1.436-1.435V6.287c0-.71-.577-1.287-1.287-1.287h-.149v7.868a.616.616 0 01-1.23 0V2.666c0-.791-.644-1.435-1.436-1.435zM6.702 11.27a.616.616 0 010 1.231H3.914a.616.616 0 010-1.23h2.788zm3.378-3.573a.616.616 0 010 1.23H3.914a.616.616 0 010-1.23h6.166zm0-3.508a.616.616 0 010 1.23H3.914a.616.616 0 010-1.23h6.166z" _fill="#666" fill-rule="nonzero"/>'
  }
})
